import React from "react";
import { Link } from 'react-router-dom'

const BtnSave = ({ click }) => (
    <div>
        <div className="admin-btnsave">
            <Link to="#" className="action-save" onClick={click}>บันทึก</Link>
        </div>
    </div>
)

export { BtnSave }